import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import storageService from '../../services/storage.service';
import { ActionRow, SubmitBtn } from '../Inspection/Inspections.styles';
import { Logo, SubTitle } from '../Payment/components/PaymentHeader/PaymentHeader.styles';
import { Container, Form, InputLabel, InputText, InputWrapper } from '../Payment/Payment.styles';
import Breadcrumb from '../Breadcrumb/Breadcrumb';
import plateService from '../../services/plate.service';
import inputMaskService from '../../services/input-mask.service';
import PlateInfo from '../../models/plate-info.entity';
import { CircularProgress } from '@mui/material';
import authService from '../../auth/auth.service';
import AuthUser from '../../auth/models/auth-user.entity';
import { ErrorMsg } from '../Home/components/Banner/components/PlateInput/PlateInput.styles';

const PlateForm = () => {
  const history = useHistory();
  const [plate, setPlate] = useState('');
  const [loading, setLoading] = useState(false);
  const [showError, setShowError] = useState(false);

  const handleChange = (e: any) => {
    const { value } = e.target;
    setPlate(inputMaskService.getMaskedValue('plate', value.toUpperCase()));
  };

  const goToPlateConfirm = () => {
    history.push('plate-confirmation');
  };

  const getAuth = () => {
    authService.getToken()
      .then((result) => {
        const user: AuthUser = new AuthUser(result);

        authService.saveAuth(user.formatAuthPayload());
      })
      .catch();
  }

  const searchByPlate = () => {
    setLoading(true);
    plateService.searchByPlate(plate)
      .then((result) => {
        const { data } = result.data;
        data.plate = plate;
        const plateInfo = new PlateInfo(data);

        storageService.setObject('plateInfo', plateInfo);
        getAuth();
        goToPlateConfirm();
      })
      .catch((error) => {
        setShowError(true);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  useEffect(() => {
    storageService.setObject('isFazInfovist', true);
  }, []);

  return (
    <Container>
      <Logo src="images/logo.svg" />
      <Breadcrumb />
      <SubTitle>Insira os dados da placa</SubTitle>
      <br /><br />
      <Form>
        <InputWrapper>
          <InputLabel>Placa do veículo</InputLabel>
          <InputText
            type="text"
            name="plate"
            maxLength="7"
            value={plate}
            onChange={handleChange}
            data-testid="input-plate"
          />
          {showError && (<ErrorMsg>Não encontramos informação para a placa informada</ErrorMsg>)}
        </InputWrapper>
        <ActionRow>
          <SubmitBtn
            onClick={searchByPlate}
            disabled={loading}
          >
            {!loading && ('Correto, continuar compra')}
            {loading && (
              <CircularProgress sx={{ color: '#fff' }} size={23} />
            )}
          </SubmitBtn>
        </ActionRow>
      </Form>
    </Container>
  );
};

export default PlateForm;
